module.exports = __webpack_public_path__ + "static/HR Portal Homepage-eaa745ea4ddf4d3275a235ecc5ca7636.jpg";